<script>
//
export let pageCopy;
export let pageTitle;
export let pageImage;
//
let theTitle;
let baseURL ="https://strapi.understory.community";
let theImg = pageImage[0];
let imgURL = baseURL + theImg.formats.small.url// ""+ JSON.stringify(theImg.formats.small.url);
let alt = theImg.alternativeText;
 //
 if(pageTitle!== null){
    theTitle=pageTitle;

}else{
    theTitle="";
}
</script>

<section>
    {#if theTitle !== ""}
         <h2>{@html theTitle}</h2>
    {/if}
    <div class="fic--plaintext-with-image img-order">
        <div class="fic--plaintext-with-promo_image">

            <img src="{imgURL}" alt="{alt}"/>
        </div>
        <div class="fic--plaintext-with-promo_text">
            {@html pageCopy}
        </div>
    </div>
</section>